export const enDE = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "Contact Options",
  description:
    "Contact Lassie for questions about insurance, claims or general support. We are available via chat, email and phone.",
  mainEntity: {
    "@type": "Organization",
    name: "Lassie AB Zweigniederlassung",
    url: "https://de.lassie.co",
    logo: "https://de.lassie.co/images/logo-with-name.svg",
    address: {
      "@type": "PostalAddress",
      streetAddress: "Münzstraße 21, Vorderhaus",
      addressLocality: "Berlin",
      postalCode: "10178",
      addressCountry: "DE",
    },
    contactPoint: [
      {
        "@type": "ContactPoint",
        contactType: "Customer support",
        email: "support@lassie.de",
        availableLanguage: ["English", "German"],
        areaServed: "DE",
        hoursAvailable: {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: [
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
          opens: "08:00",
          closes: "22:00",
        },
      },
      {
        "@type": "ContactPoint",
        contactType: "Health insurance claims",
        email: "schadenteam@lassie.de",
        availableLanguage: ["English", "German"],
        areaServed: "DE",
      },
      {
        "@type": "ContactPoint",
        contactType: "Liability insurance claims",
        email: "haftpflichtschaden@lassie.de",
        availableLanguage: ["English", "German"],
        areaServed: "DE",
      },
      {
        "@type": "ContactPoint",
        contactType: "partnerships",
        email: "kooperationen@lassie.de",
        availableLanguage: ["English", "German"],
        areaServed: "DE",
      },
      {
        "@type": "ContactPoint",
        contactType: "complaints",
        email: "beschwerde@lassie.de",
        availableLanguage: ["English", "German"],
        areaServed: "DE",
      },
    ],
  },
};
